/* ============================================================================
   pers-pasek-zakupu.js — dolny pasek zakupowy.

   ── CZERWONE LINIE ────────────────────────────────────────────────────────
   Pasek wyłącznie CZYTA. Zero zapisów do pól kalkulatora, zero dotykania
   #cpcPriceToken i #variantIdCustom, zero wysyłania formularza własnymi siłami.

   Przycisk jest PROXY: wywołuje `click()` na prawdziwym przycisku motywu.
   To jedyny sposób, żeby walidacja aplikacji (wymagany plik graficzny!) zadziałała
   dokładnie tak jak przy kliknięciu w oryginał. Własny submit obszedłby ją
   i przepuścił zamówienie bez grafiki.

   Zadanie 36: drugi cel proxy — kafle nakładu nakładki (przyciski ilości
   z rabatami w pasku). Klik w pasku = klik w kafel; zapis robi nakładka,
   w granicach min/max CPC. Pasek nadal niczego nie zapisuje.

   BRAK IntersectionObserver = BRAK PASKA. Świadomie: alternatywą byłby pasek
   widoczny zawsze, czyli trwale zasłaniający treść. Natywny przycisk działa
   wszędzie bez zmian, więc nikt nic nie traci.
   ============================================================================ */

(function () {
  'use strict';

  var pasek = document.getElementById('pers-pasek');
  if (!pasek) return;

  var natywny = document.querySelector('#main-product .product-form__submit');
  // Bez oryginału nie ma czego proxykować — pasek bez działającego przycisku
  // byłby gorszy niż jego brak.
  if (!natywny) return;

  if (typeof IntersectionObserver !== 'function') return;

  var formularz = natywny.closest('form');
  var konfig = pasek.querySelector('.pers-pasek__konfig');
  var cenaEl = pasek.querySelector('.pers-pasek__cena');
  var cta = pasek.querySelector('.pers-pasek__cta');

  // TRYB. Pasek powstal pod kalkulator i czyta jego pola: `#priceTicker`
  // oraz obecnosc wgranego pliku. Na produkcie WARIANTOWYM nie ma ani jednego,
  // ani drugiego — cene i opis wariantu wypelnia buy box, a pliku nie ma po co
  // pilnowac, bo wariant jest zawsze wybrany (Shopify tego pilnuje sam).
  //
  // Bez tego przelacznika pasek na gotowych wzorach probowalby czekac na
  // kalkulator, ktory nigdy nie przyjdzie, i po kliknieciu przewijalby do
  // nieistniejacego pola pliku.
  var natywnyTryb = pasek.dataset.tryb === 'natywny';

  /* ------------------------------------------------ pokazywanie i chowanie */

  // ZADANIE 36 (prosba Wiktora, 13.10): pasek pokazuje sie DOPIERO, gdy klient
  // zjechal POD oryginalny przycisk (kotwica nad gorna krawedzia ekranu). Wczesniej
  // pokazywal sie zawsze, gdy przycisku nie bylo widac — takze na starcie strony,
  // zanim klient w ogole doszedl do kalkulatora, i zaslanial kalkulator od dolu.
  // PRZYCISK JEST PODMIENIANY (zmierzone 13.10.2026 na kisscut i autach): aplikacja
  // kalkulatora zastępuje oryginalny przycisk NOWYM węzłem. Referencja z chwili
  // startu wskazuje wtedy węzeł odłączony od dokumentu — prostokąt 0×0, a jego
  // click() nie ma formularza do wysłania. Dlatego aktualny przycisk bierzemy
  // ze strony przy każdym użyciu, a referencji startowej używamy tylko w zapasie.
  function aktualnyPrzycisk() {
    var p = document.querySelector('#main-product .product-form__submit');
    return p && p.isConnected ? p : natywny;
  }
  var biezacaKotwica = natywny;
  function ustawWidocznosc(pokaz) {
    pasek.classList.toggle('pers-pasek--widoczny', pokaz);
    // aria-hidden idzie w parze z widocznoscia: schowany pasek nie ma byc
    // czytany, a jego przycisk nie ma lapac fokusu.
    pasek.setAttribute('aria-hidden', pokaz ? 'false' : 'true');
    cta.tabIndex = pokaz ? 0 : -1;
  }
  function przelicz() {
    // Kotwica nakładki (auto) ma pierwszeństwo; bez niej — AKTUALNY przycisk.
    var k = document.querySelector('[data-pers-kotwica-paska]') || aktualnyPrzycisk();
    if (k !== biezacaKotwica) {
      obserwator.unobserve(biezacaKotwica);
      obserwator.observe(k);
      biezacaKotwica = k;
    }
    var r = k.getBoundingClientRect();
    // Prostokąt zerowy = węzeł schowany albo odłączony — nie wiemy, gdzie jest
    // przycisk, więc nie pokazujemy paska (lepiej brak paska niż pasek na kalkulatorze).
    ustawWidocznosc(r.height > 0 && r.bottom < 0);
  }
  var obserwator = new IntersectionObserver(function () { przelicz(); }, { rootMargin: '0px 0px -10px 0px' });
  // Obserwator wola nas tylko przy ZMIANIE przeciecia. Szybki skok nad przycisk
  // (koniec strony, kotwica) moze nie przejsc przez stan „widoczny” — dlatego
  // dodatkowo przewijanie, zdlawione do jednej klatki.
  var klatka = 0;
  window.addEventListener('scroll', function () {
    if (klatka) return;
    klatka = requestAnimationFrame(function () { klatka = 0; przelicz(); });
  }, { passive: true });

  // Kotwica widocznosci: domyslnie oryginalny przycisk motywu. Na szablonach,
  // gdzie nakladka chowa oryginal i stawia wlasne CTA, oryginal jest przyciety
  // do kadru 1x1 i jego pozycja przestaje odpowiadac temu, co widzi klient.
  // Wtedy patrzymy na CTA nakladki, oznaczone atrybutem.
  //
  // Nakladka montuje sie PO tym skrypcie (czeka na kalkulator wstrzykiwany
  // przez aplikacje), wiec kotwice trzeba przelaczyc, gdy sie pojawi.
  obserwator.observe(natywny);

  var wlasna = document.querySelector('[data-pers-kotwica-paska]');
  if (!wlasna) {
    var szukacz = new MutationObserver(function () {
      var k = document.querySelector('[data-pers-kotwica-paska]');
      if (!k) return;
      szukacz.disconnect();
      clearTimeout(limitKotwicy);
      obserwator.unobserve(natywny);
      obserwator.observe(k);
      biezacaKotwica = k;
    });
    szukacz.observe(document.documentElement, { childList: true, subtree: true });
    var limitKotwicy = setTimeout(function () { szukacz.disconnect(); }, 15000);
  } else {
    obserwator.unobserve(natywny);
    obserwator.observe(wlasna);
    biezacaKotwica = wlasna;
  }

  /* ------------------------------------------------------------ proxy CTA */

  // Czy plik graficzny jest wgrany. WYLACZNIE odczyt — pole pliku i ukryte pole
  // z adresem pliku, ktore aplikacja wypelnia po udanym wgraniu.
  function brakPliku() {
    var plik = document.querySelector('#calculator input[type="file"]');
    var adres = document.querySelector('#calculator .cpc-file-url-input');
    if (!plik && !adres) return false; // nie ma czego pilnowac
    var maPlik = plik && plik.files && plik.files.length > 0;
    var maAdres = adres && String(adres.value || '').trim() !== '';
    return !maPlik && !maAdres;
  }

  cta.addEventListener('click', function () {
    // Pytanie o zgode, zanim cokolwiek zrobimy.
    //
    // Reguly "co wolno kupic" zaleza od PRODUKTU (arkusze wymagaja pliku,
    // auto wymaga pliku ALBO napisu z wybranym krojem), a pasek jest wspolny.
    // Zamiast wpisywac tu warunki kolejnych kalkulatorow, pasek pyta —
    // zdarzeniem odwolywalnym — i respektuje weto.
    //
    // Gdy nikt nie slucha (dzisiejsze arkusze), zdarzenie przechodzi bez zmian
    // i dalsza czesc dziala dokladnie jak dotad.
    var pytanie = new CustomEvent('pers:przed-zakupem', {
      cancelable: true, bubbles: true, detail: { obsluzone: false }
    });
    var wolno = document.dispatchEvent(pytanie);
    if (!wolno) return;   // zawetowane — nasluchujacy pokazal wlasny komunikat

    // Zaden preventDefault, zadnego submit(). Klikamy oryginal i oddajemy
    // sterowanie motywowi oraz aplikacji. AKTUALNY oryginal — referencja ze
    // startu bywa odlaczona (aplikacja podmienia przycisk), a klik w odlaczony
    // wezel nie wysyla niczego (zadanie 36).
    natywny = aktualnyPrzycisk();
    natywny.click();

    // Gdy walidacje przejal ktos inny, jego zdanie jest ostateczne: nasza
    // awaryjna kontrola pliku nie ma tu racji bytu. Na aucie plik jest
    // OPCJONALNY i ta kontrola przewijalaby do uploadu przy poprawnym
    // zamowieniu z samym napisem.
    if (pytanie.detail && pytanie.detail.obsluzone) return;

    // W trybie natywnym nie ma pliku do pilnowania — wariant jest zawsze
    // wybrany, a walidacje robi Shopify.
    if (natywnyTryb) return;

    // Sciezka trzecia, DETERMINISTYCZNA. Dwie pozostale sa pasywne: czekaja
    // az przegladarka albo aplikacja zglosi blad. Jesli aplikacja blokuje
    // wysylke po swojemu i nie robi ani jednego, ani drugiego, klient stoi
    // na dole strony i nic sie nie dzieje.
    //
    // Dlatego po kliknieciu sprawdzamy sam STAN pola pliku — czysty odczyt,
    // bez checkValidity i bez dotykania walidacji — i przewijamy do formularza.
    // `focus()` ustawia punkt uwagi, nie zmienia zadnej wartosci.
    setTimeout(function () {
      if (!brakPliku()) return;
      var plik = document.querySelector('#calculator input[type="file"]');
      pokazFormularz(plik || formularz);
      if (plik && typeof plik.focus === 'function') plik.focus({ preventScroll: true });
    }, 60);
  });

  // Gdy walidacja zablokuje wysylke, klient stoi na dole strony i nie widzi,
  // co jest nie tak. Przewijamy do formularza — pasywnie, bez ingerencji
  // w sama walidacje.
  function pokazFormularz(cel) {
    var el = cel || formularz;
    if (!el || typeof el.scrollIntoView !== 'function') return;
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  if (formularz) {
    // Sciezka natywna: zdarzenie "invalid" nie babelkuje, wiec faza przechwytywania.
    formularz.addEventListener('invalid', function (e) {
      pokazFormularz(e.target);
    }, true);
  }

  // Sciezka aplikacji: CPC pokazuje wlasny komunikat w #alert-block zamiast
  // korzystac z walidacji przegladarki. Reagujemy na jego POJAWIENIE SIE,
  // nie na tresc — tresc bywa podmieniana przez skrypt panelu.
  var alertBox = document.getElementById('alert-block');
  if (alertBox) {
    var bylWidoczny = alertBox.offsetParent !== null;
    new MutationObserver(function () {
      var jest = alertBox.offsetParent !== null;
      if (jest && !bylWidoczny) pokazFormularz(alertBox);
      bylWidoczny = jest;
    }).observe(alertBox, { attributes: true, childList: true, characterData: true, subtree: true });
  }

  /* ------------------------------------------------- odczyt konfiguracji */

  function poleWg(wzorzec) {
    var boxy = document.querySelectorAll('#calculator .element[data-element]');
    for (var i = 0; i < boxy.length; i++) {
      if (wzorzec.test(boxy[i].getAttribute('data-element') || '')) {
        return boxy[i].querySelector('input');
      }
    }
    return null;
  }

  function liczba(input) {
    if (!input) return NaN;
    var v = parseFloat(String(input.value).replace(',', '.').replace(/\s/g, ''));
    return isFinite(v) ? v : NaN;
  }

  function odswiezKonfig() {
    var szer = liczba(poleWg(/szerok/i));
    var wys = liczba(poleWg(/wysok/i));
    var szt = liczba(poleWg(/nak\w?ad/i));

    var czesci = [];
    if (isFinite(szer) && isFinite(wys) && szer > 0 && wys > 0) {
      czesci.push(szer + '×' + wys + ' mm');
    }
    if (isFinite(szt) && szt > 0) czesci.push(szt + ' szt');

    // GUARD: nic sensownego do pokazania -> chowamy linijke zamiast zostawiac
    // sam separator albo puste miejsce.
    if (!czesci.length) { konfig.hidden = true; return; }
    konfig.textContent = czesci.join(' · ');
    konfig.hidden = false;
  }

  function odswiezCene(ticker) {
    var tekst = (ticker.textContent || '').trim();
    // Ticker moze byc jeszcze pusty albo niesc stan posredni aplikacji.
    if (!/^\d+([.,]\d{1,2})?$/.test(tekst)) { cenaEl.hidden = true; return; }
    cenaEl.textContent = tekst.replace('.', ',') + ' zł';
    cenaEl.hidden = false;
  }

  /* --------------------------------------------------- podpiecie do CPC */

  // Kalkulator jest wstrzykiwany po stronie klienta. Pasek dziala od razu
  // (przycisk jest markupem serwerowym), a skrot konfiguracji i cena
  // dopinaja sie, gdy aplikacja skonczy budowac pola.
  function podepnijCPC() {
    var ticker = document.getElementById('priceTicker');
    var pola = document.querySelectorAll('#calculator .element[data-element] input');
    if (!ticker || pola.length < 3) return false;

    odswiezKonfig();
    odswiezCene(ticker);

    new MutationObserver(function () { odswiezCene(ticker); })
      .observe(ticker, { childList: true, characterData: true, subtree: true });

    for (var i = 0; i < pola.length; i++) {
      pola[i].addEventListener('input', odswiezKonfig);
      pola[i].addEventListener('change', odswiezKonfig);
    }
    return true;
  }

  /* ------------------------------------------ przyciski ilosci (zadanie 36) */

  // Rabaty hurtowe w pasku: KOPIA WIDOKU kafli nakladki, nie nowy wybor. Klikniecie
  // przycisku w pasku klika odpowiadajacy KAFEL nakladki (proxy, jak CTA), wiec
  // wartosc w polu ustawia wylacznie nakladka — w swoich granicach min/max —
  // a cene liczy CPC. Pasek dalej niczego nie zapisuje.
  // Na telefonie przyciski chowa CSS sekcji (pasek jest tam za waski) — ta sama
  // decyzja co na gotowych wzorach.
  function podepnijKafle() {
    var kafle = document.querySelectorAll('#calculator .pcv-kafle .pcv-kafel[aria-pressed]');
    if (!kafle.length) return false;
    var inner = pasek.querySelector('.pers-pasek__inner');
    if (!inner || pasek.querySelector('.pers-pasek__chipy')) return true;
    var grupa = document.createElement('div');
    grupa.className = 'pers-pasek__chipy';
    grupa.setAttribute('role', 'group');
    grupa.setAttribute('aria-label', 'Nakład');
    var pary = [];
    Array.prototype.forEach.call(kafle, function (kafel) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pers-pasek__chip';
      var n = kafel.querySelector('.pcv-kafel__n');
      var rabat = kafel.querySelector('.pcv-kafel__rabat');
      b.appendChild(document.createTextNode((n ? n.textContent : '') + ' szt'));
      if (rabat) {
        var z = document.createElement('span');
        z.className = 'pers-pasek__znacznik';
        z.textContent = rabat.textContent;
        b.appendChild(z);
      }
      b.addEventListener('click', function () { kafel.click(); });
      grupa.appendChild(b);
      pary.push([kafel, b]);
    });
    function synchronizuj() {
      pary.forEach(function (p) {
        var akt = p[0].getAttribute('aria-pressed') === 'true';
        p[1].classList.toggle('pers-pasek__chip--aktywny', akt);
        p[1].setAttribute('aria-pressed', akt ? 'true' : 'false');
      });
    }
    pary.forEach(function (p) { new MutationObserver(synchronizuj).observe(p[0], { attributes: true, attributeFilter: ['aria-pressed'] }); });
    synchronizuj();
    inner.insertBefore(grupa, cta);
    return true;
  }

  // W trybie natywnym tresc paska wypelnia buy box gotowych wzorow — tu nie ma
  // czego podpinac ani na co czekac.
  if (natywnyTryb) return;

  if (!podepnijKafle()) {
    var czuwaczKafli = new MutationObserver(function () {
      if (podepnijKafle()) { czuwaczKafli.disconnect(); clearTimeout(limitKafli); }
    });
    czuwaczKafli.observe(document.documentElement, { childList: true, subtree: true });
    var limitKafli = setTimeout(function () { czuwaczKafli.disconnect(); }, 15000);
  }

  if (!podepnijCPC()) {
    var czuwacz = new MutationObserver(function () {
      if (podepnijCPC()) { czuwacz.disconnect(); clearTimeout(limit); }
    });
    czuwacz.observe(document.documentElement, { childList: true, subtree: true });
    var limit = setTimeout(function () { czuwacz.disconnect(); }, 15000);
  }
})();
